import styled from 'styled-components';

const inputStyle = {
  boxSizing: 'border-box',
  background: 0,
  border: 0,
  fontSize: 'inherit',
  outline: 0,
  padding: 0,
  color: 'inherit',
  opacity: 1,
  cursor: 'text',
};

const AutosizeInputWrapper = styled.div`
  visibility: visible;
  color: inherit;
  box-sizing: border-box;
  display: block;
`;

const StyledPlaceholder = styled.div`
  top: 50%;
  position: absolute;
  transform: translateY(-50%);
  color: ${props => props.color} !important;
`;

const StyledValue = styled.div`
  top: 50%;
  color: #495057;
  max-width: calc(100% - 8px);
  position: absolute;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  box-sizing: border-box;
  transform: translateY(-50%);
`;

export {
  inputStyle,
  StyledValue,
  StyledPlaceholder,
  AutosizeInputWrapper,
};